import { render } from "./tableRead.vue?vue&type=template&id=a6e79f38&scoped=true"
import script from "./tableRead.vue?vue&type=script&lang=js"
export * from "./tableRead.vue?vue&type=script&lang=js"

import "./tableRead.vue?vue&type=style&index=0&id=a6e79f38&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e79f38"]])

export default __exports__